module.exports = __webpack_public_path__ + "static/img/bianzu2.ea7d115.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bianzu2.png
// module id = ivFc
// module chunks = 2